module.exports = __webpack_public_path__ + "img/2019-03-25.e38af897.jpg";